import { FormalizeCompany, FormalizeRequisition } from '../../../models/formalizePayload';
import { Requisition } from '../../../models/requisition';
import { UiError } from '../../../models/uiError';
export class EditSharedReqPageController {
    /*@ngInject*/
    constructor($scope, $state, $transitions, $rootScope, $timeout, requisitionService, jobService, companyService, alertsAndNotificationsService, MESSAGECONSTANTS, uibModalService, utilityService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$transitions = $transitions;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.requisitionService = requisitionService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.utilityService = utilityService;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.isTransitionAbortRequired = true;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.recruiterList = [];
        this.selectedRecruiters = [];
        this.req = {};
        this.job = {};
        this.uploadReqWizard = {};
        this.clientOrBuLabel = 'Client';
        this.requisitionNote = "";
        this.requisitionInfo = this.$stateParams.requisitionInfo;
        // flags
        this.disableUploadButtonFlag = true;
        this.savingFlag = false;
        this.step2DetailsSavedFlag = false;
        this.workflowStepsSavedFlag = false;
        this.disablePrevButtonFlag = false;
        this.disableSaveButtonFlag = true;
        this.disableNextButtonFlag = true;
        this.disableCancelButtonFlag = false;
        this.disableAllButtonsFlag = false;
        this.loadingAdjustedCandidatesCountFlag = false;
        this.step1RequestWasInProgressFlag = false;
        this.step2RequestWasInProgressFlag = false;
        this.editTitleFlag = false;
        this.editJobLocationFlag = false;
        this.step1DetailsTempObject = {};
        this.workflowStepsTempObject = {};
        this.showWizardSteps = false;
        //error objects
        this.step1Error = null;
        this.step2Error = null;
        this.jobId = this.$stateParams.jobId;
        this.corporateId = this.$stateParams.corporateCompanyId;
        this.jobName = this.$stateParams.jobName;
        this.jobType = this.$stateParams.jobType;
        this.buId = this.$stateParams.buId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.updateActionButtons();
        this.req = new Requisition();
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.userId = this.$rootScope.userDetails.id;
        this.getAssignableRecruitersList(() => {
            this.getAssignedRecruiters(() => {
                this._setAssignedRecruiters();
                this._getSharedRequisitionNote(() => {
                    this._createStepTempObject(2);
                });
            });
        });
        // error objects
        this.step1Error = new UiError();
        this.step2Error = new UiError();
        // edit mode
        this.currentJobStatus = 'OPEN';
        $('#uploadReqWizard').wizard();
        // }
        this.showWizardSteps = true;
        // get license preferences as job id is available
        this.getCorporateCompanyLicensePreference(() => {
            this.disableNextButtonFlag = false;
        });
        //set the flags for edit mode
        this.disableUploadButtonFlag = true;
        this.step2DetailsSavedFlag = true;
        this._initStepsWizard();
        this._handleBrowserEvents();
        this.setFormalizeActivityPayload();
    }
    _initStepsWizard() {
        // Handle Wizard operations
        $('#uploadReqWizard').on('actionclicked.fu.wizard', (evt, data) => {
            if (data.direction == "next") {
                let currentStep = data.step;
                switch (currentStep) {
                    case 1:
                        // Do Nothing
                        break;
                    case 2:
                        if (this.step1RequestWasInProgressFlag) {
                            // save or request was in progress and it is now completed. The success has has triggered a next event.
                            // set the flag, do nothing and move to next step.
                            this._enableStepActionsOnWizard(data.step);
                        }
                        else {
                            // there was no step2 request or save in progress. the event was triggered by user click of next button
                            if (this._isStepDataValid(data.step)) {
                                if (this._hasStepDataChanged(data.step)) {
                                    if (this._hasRecruitersBeingUnAssigned()) {
                                        evt.preventDefault();
                                        this._showRecruitersUnAssignedWarning(() => {
                                            this.step1RequestWasInProgressFlag = true;
                                            this.saveStep1Details(() => {
                                                // move to next step as the save is done.
                                                $("#uploadReqWizard").wizard('next');
                                                this._enableStepActionsOnWizard(3);
                                                this.disableSaveButtonFlag = true;
                                            }, (error) => {
                                                this._enableStepActionsOnWizard(3);
                                                // show error messages
                                                if (this.$rootScope.isOnline) {
                                                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                                }
                                                // no move to next step.
                                            });
                                        }, () => {
                                            // this.recruiterList = angular.copy(this.step1DetailsTempObject.recruiters);
                                            this._setAssignedRecruiters();
                                        });
                                    }
                                    else {
                                        this.step1RequestWasInProgressFlag = true;
                                        this.saveStep1Details(() => {
                                            $("#uploadReqWizard").wizard('next');
                                            this.disableSaveButtonFlag = true;
                                            this._enableStepActionsOnWizard(3);
                                        }, (error) => {
                                            this._enableStepActionsOnWizard(3);
                                            // show error messages
                                            if (this.$rootScope.isOnline) {
                                                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                            }
                                            // no move to next step.
                                        });
                                    }
                                }
                                else {
                                    this._createStepTempObject(data.step + 1);
                                }
                            }
                            else {
                                // prevent the move. Validation errors will show up.
                                evt.preventDefault();
                            }
                            // if a request was triggered, prevent the default behaviour of moving to next, till the requests are completed.
                            if (this.step1RequestWasInProgressFlag) {
                                // prevent default move.
                                evt.preventDefault();
                                this.disableAllButtonsFlag = true;
                            }
                        }
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
            }
            else if (data.direction == "previous") {
                switch (data.step) {
                    case 1:
                        // Do Nothing
                        break;
                    case 2:
                        this._createStepTempObject(data.step - 1);
                        // not possible
                        break;
                    case 3:
                        // do nothing
                        break;
                    default:
                        break;
                }
            }
        });
        $('#uploadReqWizard').on('finished.fu.wizard', (evt, data) => {
            this.$state.go('missioncontrol.requisitions');
        });
        $('#uploadReqWizard').on('changed.fu.wizard', (evt, data) => {
            switch (data.step) {
                case 1:
                case 2:
                case 3:
                    this.updateActionButtons();
                    break;
            }
        });
    }
    _hasRecruitersBeingUnAssigned() {
        return this.step1DetailsTempObject.recruiterIds.length > this.selectedRecruiters.length;
    }
    _showRecruitersUnAssignedWarning(saveCallback, cancelCallback) {
        let selectedRecruiterIds = this.selectedRecruiters.map((val, index) => {
            return val.userId;
        });
        let removedRecruiterIds = _.difference(this.step1DetailsTempObject.recruiterIds, selectedRecruiterIds);
        console.log(removedRecruiterIds);
        let recruiterNames = [];
        angular.forEach(removedRecruiterIds, (recruiterId, recruiterIdIndex) => {
            angular.forEach(this.recruiterList, (recruiter, recruiterIndex) => {
                if (recruiterId == recruiter.userId) {
                    recruiterNames.push(recruiter.name);
                }
            });
        });
        let warningMessage = this._getWarningMessage(recruiterNames);
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: warningMessage,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    saveCallback();
                }
                else {
                    cancelCallback();
                }
            }
        });
    }
    _getWarningMessage(recruiterNames) {
        let message = "<b>";
        let totalCount = recruiterNames.length;
        angular.forEach(recruiterNames, (name, index) => {
            if (index == totalCount - 1) {
                message = message + name;
            }
            else if (index == totalCount - 2) {
                message = message + name + " & ";
            }
            else {
                message = message + name + ", ";
            }
        });
        return message + "</b> shall be removed as assigned recruiter(s) from all the candidates in the requisition. Do you still want to continue?";
    }
    _createStepTempObject(currentStep) {
        switch (currentStep) {
            case 1:
                // Do Nothing
                break;
            case 2:
                let recruiterIds = [];
                angular.forEach(this.selectedRecruiters, (val, key) => {
                    recruiterIds.push(val.userId);
                });
                this.step1DetailsTempObject = {
                    jobId: this.jobId,
                    vendorId: this.companyId,
                    recruiterIds: recruiterIds,
                    requisitionNote: this.requisitionNote
                };
                break;
            case 3:
                break;
            default:
                break;
        }
    }
    _isStepDataValid(currentStep) {
        let stepDataValidityFlag = true;
        switch (currentStep) {
            case 1:
                // Do Nothing
                break;
            case 2:
                // set the form to submitted
                this.forms.step1Form.$submitted = true;
                //check all the values one by one.
                if (this.forms.step1Form.$invalid || (this.selectedRecruiters.length == 0)) {
                    this.step1Error.hasErrorFlag = true;
                    this.step1Error.errorMessage = 'Please enter all mandatory fields.';
                    stepDataValidityFlag = false;
                }
                else {
                    this.step1Error.hasErrorFlag = false;
                    this.step1Error.errorMessage = '';
                }
                break;
            case 3:
                break;
            default:
                break;
        }
        return stepDataValidityFlag;
    }
    _hasStepDataChanged(currentStep) {
        let stepDataHasChangedFlag = false;
        switch (currentStep) {
            case 1:
                break;
            case 2:
                let recruiterIds = [];
                angular.forEach(this.selectedRecruiters, (val, key) => {
                    recruiterIds.push(val.userId);
                });
                let currentStep1DataObject = {
                    jobId: this.jobId,
                    vendorId: this.companyId,
                    recruiterIds: recruiterIds,
                    requisitionNote: this.requisitionNote
                };
                stepDataHasChangedFlag = !(_.isEqual(this.step1DetailsTempObject, currentStep1DataObject));
                break;
            case 3:
                break;
            default:
                break;
        }
        return stepDataHasChangedFlag;
    }
    _enableStepActionsOnWizard(currentStep) {
        switch (currentStep) {
            case 1:
                //do nothing
                break;
            case 2:
                //do nothing
                break;
            case 3:
                this.step1RequestWasInProgressFlag = false;
                break;
            default:
                break;
        }
        this.disableAllButtonsFlag = false;
    }
    wizardSaveStepData() {
        let currentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        if (this._isStepDataValid(currentStep)) {
            if (this._hasStepDataChanged(currentStep)) {
                switch (currentStep) {
                    case 1:
                        // Do Nothing
                        break;
                    case 2:
                        if (this._hasRecruitersBeingUnAssigned()) {
                            this._showRecruitersUnAssignedWarning(() => {
                                this.disableAllButtonsFlag = true;
                                this.savingFlag = true;
                                this.saveStep1Details(() => {
                                    this.disableAllButtonsFlag = false;
                                    this.savingFlag = false;
                                    this._enableStepActionsOnWizard(3);
                                    if (this.$rootScope.isOnline) {
                                        let successMessage = 'The Requisition details have been saved in Draft Status.';
                                        if (this.currentJobStatus == 'OPEN') {
                                            successMessage = 'The Requisition details have been saved.';
                                        }
                                        this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                    }
                                    this._createStepTempObject(currentStep);
                                }, (error) => {
                                    this.disableAllButtonsFlag = false;
                                    this.savingFlag = false;
                                    if (this.$rootScope.isOnline) {
                                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                    }
                                });
                            }, () => {
                                // this.job.recruiters = angular.copy(this.step1DetailsTempObject.recruiters);
                                this._setAssignedRecruiters();
                            });
                        }
                        else {
                            this.disableAllButtonsFlag = true;
                            this.savingFlag = true;
                            this.saveStep1Details(() => {
                                this._enableStepActionsOnWizard(3);
                                this.disableAllButtonsFlag = false;
                                this.savingFlag = false;
                                if (this.$rootScope.isOnline) {
                                    let successMessage = 'The Requisition details have been saved in Draft Status.';
                                    if (this.currentJobStatus == 'OPEN') {
                                        successMessage = 'The Requisition details have been saved.';
                                    }
                                    this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
                                }
                                this._createStepTempObject(currentStep);
                            }, (error) => {
                                this.disableAllButtonsFlag = false;
                                this.savingFlag = false;
                                if (this.$rootScope.isOnline) {
                                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                }
                            });
                        }
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
            }
            else {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage('Nothing to be saved!', 'info');
                }
            }
        }
    }
    validateStepOne() {
        if (this.forms.step1Form.$submitted) {
            if (this.forms.step1Form.$invalid || (this.job.recruiters.length == 0)) {
                this.step1Error.hasErrorFlag = true;
                this.step1Error.errorMessage = 'Please enter all mandatory fields.';
            }
            else {
                this.step1Error.hasErrorFlag = false;
                this.step1Error.errorMessage = '';
            }
        }
    }
    wizardCancel() {
        this.$state.go('missioncontrol.requisitions');
    }
    resetStepData(step, successCallback) {
        this.$timeout(() => {
            switch (step) {
                case 1:
                    //do nothing
                    break;
                case 2:
                    //do nothing
                    this._setAssignedRecruiters();
                    break;
                case 3:
                    break;
                default:
                    break;
            }
            if (successCallback) {
                successCallback();
            }
        }, 100);
    }
    getAssignableRecruitersList(successCallback) {
        this.loadingRecruitersFlag = true;
        this.requisitionService.getVendorRecruiters(this.companyId, this.jobId, (data) => {
            this.loadingRecruitersFlag = false;
            angular.forEach(data, (val, key) => {
                val.name = val.firstName;
                if (!_.isNull(val.lastName)) {
                    val.name += ' ' + val.lastName;
                }
            });
            this.recruiterList = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingRecruitersFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAssignedRecruiters(successCallback) {
        this.requisitionService.getAssignedVendorRecruiters(this.jobId, this.companyId, (data) => {
            this.assignedRecruiterIds = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getSharedRequisitionNote(successCallback) {
        this.jobService.getSharedRequisitionNote(this.jobId, this.companyId, (data) => {
            this.requisitionNote = data.requisitionNote;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setAssignedRecruiters() {
        this.selectedRecruiters = [];
        angular.forEach(this.assignedRecruiterIds, (val, key) => {
            let recruiterIndex = _.findIndex(this.recruiterList, { 'userId': val });
            if (recruiterIndex !== -1) {
                this.recruiterList[recruiterIndex].selected = true;
                this.selectedRecruiters.push(this.recruiterList[recruiterIndex]);
            }
        });
    }
    getCorporateCompanyLicensePreference(successCallback, errorCallback) {
        this.jobService.getSharedJobWorkflowDetails(this.jobId, (data) => {
            this.companyLicensePreference = data;
            successCallback();
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    saveStep1Details(successCallback, errorCallback) {
        this.utilityService.showLoadingModal("Saving...");
        if (this._hasRecruitersChanged()) {
            this.savingFlag = true;
            let recruiterIds = [];
            angular.forEach(this.selectedRecruiters, (val, key) => {
                recruiterIds.push(val.userId);
            });
            let step1SaveObject = {
                jobId: this.jobId,
                vendorId: this.companyId,
                recruiterIds: recruiterIds
            };
            this.requisitionService.assignRecruiters(step1SaveObject, (data) => {
                if (this._hasNoteChanged()) {
                    this._saveRequisitionNote(successCallback, errorCallback);
                    this._createStepTempObject(2);
                }
                else {
                    this.savingFlag = false;
                    this.step2DetailsSavedFlag = true;
                    if (!_.isUndefined(successCallback)) {
                        successCallback();
                    }
                    this.utilityService.hideLoadingModal();
                }
            }, (error) => {
                this.savingFlag = false;
                if (!_.isUndefined(errorCallback)) {
                    errorCallback(error);
                }
                this.utilityService.hideLoadingModal();
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this._saveRequisitionNote(successCallback, errorCallback);
        }
    }
    _hasRecruitersChanged() {
        let recruiterIds = [];
        angular.forEach(this.selectedRecruiters, (val, key) => {
            recruiterIds.push(val.userId);
        });
        return !_.isEqual(this.step1DetailsTempObject.recruiterIds, recruiterIds);
    }
    _hasNoteChanged() {
        return this.step1DetailsTempObject.requisitionNote !== this.requisitionNote;
    }
    _saveRequisitionNote(successCallback, errorCallback) {
        this.savingFlag = true;
        let payload = {
            jobId: this.jobId,
            companyId: this.companyId,
            note: this.requisitionNote
        };
        this.jobService.addSharedRequisitionNote(payload, (data) => {
            this.savingFlag = false;
            this.step2DetailsSavedFlag = true;
            this._createStepTempObject(2);
            if (successCallback) {
                successCallback();
            }
            this.utilityService.hideLoadingModal();
        }, (error) => {
            this.savingFlag = false;
            if (errorCallback) {
                errorCallback(error);
            }
            this.utilityService.hideLoadingModal();
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    updateActionButtons() {
        let wizardCurrentStep = $('#uploadReqWizard').wizard('selectedItem').step;
        switch (wizardCurrentStep) {
            case 1:
                this.disableSaveButtonFlag = false;
                this.disablePrevButtonFlag = true;
                break;
            case 2:
                this.disableSaveButtonFlag = false;
                break;
            case 3:
                this.disableSaveButtonFlag = false;
                break;
            default:
                break;
        }
        this.$timeout(() => {
            this.$scope.$apply();
        }, 200);
    }
    //Handle navigating away when data is unsaved
    uiCanExit(transitions) {
        let toState = transitions.to().name;
        let toParams = transitions.params();
        let currentStep = $("#uploadReqWizard").wizard('selectedItem');
        if (this._hasStepDataChanged(currentStep.step) && this.isTransitionAbortRequired && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        this.isTransitionAbortRequired = false;
                        this.resetStepData(currentStep.step);
                        // Handling data change when clicked on Switch company 
                        if (this.$rootScope.switchClicked) {
                            this.$rootScope.switchClicked = false;
                            // this.companyService.showAllCompanies();
                            this.uibModalService.showAllCompanies();
                        }
                        else {
                            this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        if (this.$rootScope.switchClicked) {
                            this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._hasStepDataChanged(currentStep.step)) {
                transitions.abort();
                this.$timeout(() => {
                    // this.companyService.showAllCompanies();
                    this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    }
    _handleBrowserEvents() {
        //Handle Browser back/forward change
        let unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', (event, toState, toParams, fromState, fromParams) => {
            this.isLocationChange = this.isLocationChangeInitial;
            this.isLocationChangeInitial = true;
        });
    }
    receiveFormalizedComment(event) {
        this.requisitionNote = event;
    }
    onVoiceTranscript(transcript) {
        if (this.requisitionNote) {
            this.requisitionNote += ' ' + transcript;
        }
        else {
            this.requisitionNote = transcript;
        }
    }
    setFormalizeActivityPayload() {
        this.formalizeActivityPayload = {
            candidate: null,
            requisition: new FormalizeRequisition(this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.requisitionInfo.requisitionActualNumber),
            jobMatch: null,
            company: new FormalizeCompany(this.companyId, this.$rootScope.userDetails.company.companyName, this.buId, this.requisitionInfo.corporateBU)
        };
    }
}
EditSharedReqPageController.$inject = ['$scope', '$state', '$transitions', '$rootScope', '$timeout', 'requisitionService', 'jobService', 'companyService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'uibModalService', 'utilityService'];
// import * as TEMPLATE from './shared-req-restricted-edit-page.html';
import * as TEMPLATE from 'raw-loader!./shared-req-restricted-edit-page.html';
export const EditSharedReqPageComponent = {
    selector: 'editSharedReqPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/sharedReqRestrictedEdit/shared-req-restricted-edit-page.html',
        controller: EditSharedReqPageController
    }
};
//# sourceMappingURL=shared-req-restricted-edit-page.component.js.map